import { AutogenModelCallRecOpenItem, AutogenRowCallRecOpenItem } from "./autogen/AutogenModelCallRecOpenItem";

export class ModelCallRecOpenItem extends AutogenModelCallRecOpenItem<RowCallRecOpenItem> {
	constructor() {
		super(RowCallRecOpenItem);
	}
}

export class RowCallRecOpenItem extends AutogenRowCallRecOpenItem {
}